/* tslint:disable:variable-name */
import { Injectable, Inject } from '@angular/core';

import { ISchema, BasePersistentApiClient } from '../common/index';
import { BaseEntity, Field } from '../common/meta';
import {
    IInstanceCodeClient, instanceCodeClientT, paramsBuilderT,
    IParamsBuilder
} from '../common/interfaces';

import {
    IRoleTemplate, IRoleTemplateClient, RoleTemplateBelongsToRelationships,
    RoleTemplateHasManyRelationships
} from './interfaces';
import { AuthHttp } from '../authentication/authentication.service';

export class RoleTemplate extends BaseEntity<IRoleTemplate> implements IRoleTemplate {

    public static readonly type: string = 'role_template';

    @Field()
    id: string;

    @Field()
    name: string;

    @Field()
    kind: string;
}

@Injectable()
export class RoleTemplateClient
    extends BasePersistentApiClient<IRoleTemplate, RoleTemplateBelongsToRelationships, RoleTemplateHasManyRelationships>
    implements IRoleTemplateClient {

    protected static classConfig: ISchema = {
        apiResourceName: 'role_templates'
    };

    constructor(
        http: AuthHttp,
        @Inject(instanceCodeClientT) instanceCodeClient: IInstanceCodeClient,
        @Inject(paramsBuilderT) paramsBuilder: IParamsBuilder
    ) {
        super(http, instanceCodeClient, paramsBuilder);
    }

    protected implementationClass() {
        return RoleTemplate;
    }
}
